<template>
  <div class="customer-container">
    <div class="header-toolbar">
      <h2>我的订单状态</h2>
      <div>
        <el-button type="info" @click="goBack" style="margin-right: 10px"
          >返回</el-button
        >
      </div>
    </div>

    <el-form
      :inline="true"
      :model="searchForm"
      class="search-form"
      label-width="80px"
      style="display: flex; align-items: center; width: 100%"
    >
      <el-form-item label="客户编号">
        <el-input
          v-model="searchForm.customerNo"
          placeholder="请输入客户编号搜索"
          style="width: 200px"
        ></el-input>
      </el-form-item>
      <el-form-item label="PI号">
        <el-input
          v-model="searchForm.piNo"
          placeholder="请输入PI号搜索"
          style="width: 200px"
        ></el-input>
      </el-form-item>
      <el-form-item label="订单状态">
        <el-select
          v-model="searchForm.status"
          placeholder="请选择状态"
          style="width: 180px"
          clear="true"
        >
          <el-option
            v-for="(label, value) in statusMap"
            :key="value"
            :label="label"
            :value="value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getCustomerStatus">查询</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-form-item>
      <el-form-item style="margin-left: auto; margin-right: 16px">
        <el-button type="primary" @click="saveCustomerStatus">保存</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="statusList"
      border
      style="width: 100%; margin-top: 10px"
      stripe
      v-loading="loading"
      element-loading-text="加载中..."
    >
      <el-table-column
        label="客户编号"
        prop="customerNo"
        style="width: 15%"
        align="center"
      ></el-table-column>
      <el-table-column
        label="PI号"
        prop="piNo"
        style="width: 15%"
        align="center"
      ></el-table-column>
      <el-table-column label="订单状态" align="center">
        <template #default="scope">
          <el-select
            v-model="scope.row.selectedOrderStatus"
            placeholder="请选择状态"
            style="width: 180px"
          >
            <el-option
              v-for="(label, value) in statusMap"
              :key="value"
              :label="label"
              :value="value"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNum"
      :page-sizes="[5, 10, 20]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 20px; text-align: right"
      v-if="total > 0"
    ></el-pagination>

    <div v-if="statusList.length === 0 && !loading" class="no-order-tip">
      暂无绑定您客户编号的订单数据～
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import { Message } from "element-ui";

export default {
  name: "CustomerStatusList", // 修正拼写：CustomerstatusList → CustomerStatusList（规范命名）
  data() {
    return {
      statusList: [],
      statusMap: {
        1: "Not selected",
        2: "In production",
        3: "In packing",
        4: "Ready for shipping",
        5: "Completed",
      },
      searchForm: { customerNo: "", piNo: "", status: "" },
      pageNum: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      userInfo: JSON.parse(localStorage.getItem("userInfo")) || {},
    };
  },
  mounted() {
    this.getCustomerStatus();
  },
  methods: {
    // 1. 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    // 2. 重置搜索
    resetSearch() {
      this.searchForm.customerNo = "";
      this.searchForm.piNo = "";
      this.pageNum = 1;
      this.searchForm.status = "";
      this.getCustomerStatus();
    },
    // 3. 每页条数变更
    handleSizeChange(val) {
      this.pageSize = val;
      this.getCustomerStatus();
    },
    // 4. 当前页变更
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getCustomerStatus();
    },
    // 5. 查询订单状态（🔥 核心修改：路径添加/api前缀）
    async getCustomerStatus() {
      this.loading = true;
      try {
        const res = await request.get("/api/order/admin/status", {
          params: {
            customerNo: this.searchForm.customerNo,
            piNo: this.searchForm.piNo,
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            status: this.searchForm.status,
          },
        });

        if (res.code === 200) {
          const records = res.records || [];
          this.statusList = records.map((item) => ({
            ...item, // 保留原数据所有字段（包括id）
            selectedOrderStatus: item.orderStatus || "1", // 绑定下拉框选中值
          }));
          this.total = res.total || 0;
        } else {
          Message.error(res.msg || "查询订单状态失败");
        }
      } catch (err) {
        console.error("查询订单状态失败：", err);
        console.error("实际请求URL：", err.config?.url); // 便于验证路径
        Message.error("网络异常，请重试");
      } finally {
        this.loading = false;
      }
    },
    // 6. 批量保存订单状态（🔥 核心修改：路径添加/api前缀）
    async saveCustomerStatus() {
      // 筛选出已选择状态的记录，且必须包含id
      const submitData = this.statusList
        .filter(
          (row) =>
            row.selectedOrderStatus !== "" &&
            row.selectedOrderStatus !== undefined &&
            row.id // 校验id存在
        )
        .map((row) => ({
          id: row.id, // 传递状态表主键ID（后端按ID精准更新）
          customerNo: row.customerNo,
          piNo: row.piNo,
          orderStatus: row.selectedOrderStatus,
        }));

      if (submitData.length === 0) {
        Message.warning("请至少选择一个订单状态，或确保数据已加载完成");
        return;
      }

      try {
        // 错误路径：/order/admin/allUpdate → 正确路径：/api/order/admin/allUpdate
        const res = await request.post(
          "/api/order/status/batchUpdate",
          submitData
        );
        if (res.code === 200) {
          Message.success("批量保存成功");
          this.getCustomerStatus(); // 保存后刷新列表
        } else {
          Message.error("批量保存失败：" + (res.msg || "未知错误"));
        }
      } catch (error) {
        Message.error("批量保存失败：网络异常或后端错误");
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
.customer-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}
.header-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.search-form {
  background-color: #fff;
  padding: 15px;
  border-radius: 4px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.05);
}
.el-table th.el-table__cell,
.el-table td.el-table__cell {
  text-align: center !important;
}
.no-order-tip {
  text-align: center;
  padding: 50px;
  color: #666;
  font-size: 16px;
}
.el-loading-mask {
  background-color: rgba(255, 255, 255, 0.7);
}
</style>